import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { clients, gradientColor } from "./constants";

const Clients = () => {
  const ClientItem = ({ name }) => (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        minWidth: "250px",
        mx: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        borderRadius: "15px",
        backgroundColor: "#fff",
        transition: "all 0.3s ease",
        overflow: "hidden",
        "&:hover": {
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
          borderColor: "#2c82ad",
          background: "linear-gradient(135deg,#2c82ad,#67b26f)",
          "& .icon": {
            color: "white",
            transform: "scale(1.2)",
          },
          "& .name": {
            color: "white",
            fontWeight: 600,
          },
        },
      }}
    >
      <Typography
        variant="body1"
        className="name"
        sx={{
          color: "#333",
          fontWeight: 500,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontSize: "1rem",
          lineHeight: "1.5",
          flexGrow: 1,
          transition: "all 0.3s ease",
        }}
      >
        {name}
      </Typography>
    </Paper>
  );

  return (
    <Box id="clients" sx={{ overflow: "hidden", marginBottom: 15 }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          sx={{
            background: gradientColor,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: "800 !important",
            marginBottom: 5,
            textAlign: "center",
            color: "#333333",
            position: "relative",
            fontSize: {
              xs: "1.8rem",
              md: "2.125rem",
            },
          }}
        >
          Our Major Clients
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          animation: "scroll 40s linear infinite",
          "@keyframes scroll": {
            "0%": { transform: "translateX(0)" },
            "100%": { transform: "translateX(-50%)" },
          },
          "&:hover": {
            animationPlayState: "paused",
          },
          mb: 3,
        }}
      >
        {clients.map((client, index) => (
          <ClientItem key={`row1-${index}`} name={client} />
        ))}
      </Box>
      <Box
        sx={{
          display: "flex",
          width: "max-content",
          pb: 3,
          animation: "scroll-reverse 35s linear infinite",
          "@keyframes scroll-reverse": {
            "0%": { transform: "translateX(-50%)" },
            "100%": { transform: "translateX(0)" },
          },
          "&:hover": {
            animationPlayState: "paused",
          },
        }}
      >
        {clients
          .slice()
          .reverse()
          .map((client, index) => (
            <ClientItem key={`row2-${index}`} name={client} />
          ))}
      </Box>
    </Box>
  );
};

export default Clients;
